<template>
  <div class="educa_wrap">
    <Header></Header>
    <div class="educa_main">
      <div class="educa_menu">
        <div class="educa_menu_box" :style="{width:!isOpen?'0px':'140px'}">
          <ul>
            <li v-for="(item,index) in routerLink" :key="index" :class="{active : index===curId}" @click="tabSwitch(item,index)">{{item.name}}</li>
          </ul>
        </div>
        <img src="../../../../static/images/course/close.png" alt="" v-if="isOpen" class="switchImg close" @click="isOpen=false">
        <img src="../../../../static/images/course/open.png" alt="" v-else class="switchImg open" @click="isOpen=true">
      </div>
      <div class="educa_content" :style="isOpen?'width: calc(100% - 156px)':'width: 100%'">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
  import Header from '../../header/header'
  // import * as Api from "../../../api/examLinkcert";
  import '@/views/szrt_revision/new_educa_module/css/educaManage.scss'
  export default {
    components: {
      Header
    },
    data() {
      return {
        routerPermissions:[], // 获取产品路由权限
        isOpen: true,
        curId: 0,
        routerLink:[],
        routerPath:'/educa'
      }
    },
    created(){
      if (sessionStorage.getItem('routerPermissions')){
        try {
          this.routerPermissions = JSON.parse( this.$AES.AES_Decrypt(sessionStorage.getItem('routerPermissions'))  )
        }catch (e) {
          console.error( 'NewHome.created',e)
        }
      }
      sessionStorage.removeItem('prodName')
      this.init();
    },
    mounted(){},
    methods:{
      init(){

        if (this.routerPermissions.length){
          let routerArr = []
          let menuArr = []
          this.routerPermissions.forEach(v=>{
            if(v.appFlag === 'platformadmin'){
              routerArr = v.arr
            }
          })
          if(routerArr.length>0){
            routerArr.forEach(v=>{
              if(v.name==='教务管理'){
                v.children.forEach(val=>{
                  menuArr.push({
                    name: val.name,
                    hidden: true,
                    path: val.url
                  })
                })
              }
            })
          }
          this.routerLink = menuArr
          this.routerPath = this.routerLink[0].path
        }

        // console.log('--this.routerLink--', this.routerPath )

        // if(this.$route.path==='/educa'){
        //
        // }
        this.$router.push({path:this.routerPath})
        this.routerLink.forEach((v,i)=>{
          if(this.$route.path===v.path){
            this.curId = i
          }
          if(this.$route.path==='/educa/appliedList'){
            if(v.name==='考试报名'){
              this.curId = i
            }
          }
        })
      },
      tabSwitch(item,i){
        let deptId = sessionStorage.getItem('deptId')
        if(item.name === '校考管理') {
          if(deptId === '1') {
            sessionStorage.setItem('idx', 1)
          } else { // 不是中联管理员，跳入到无数据页面
            sessionStorage.setItem('idx', 0)
          }
        } else {
          sessionStorage.setItem('idx', 1)
        }
        this.curId = i
        this.$router.push(item.path)
        // if(item.name == "校考管理") {
        //   window.loading = this.$loading({
        //     lock: true,
        //     target: '.educa_manage_wrap'
        //   });
        //   this.curId = i
        // Api.getAdminPreData().then(res => {
        //   if(res.code == '0') {
        //     // this.$message.success(res.msg)
        //     this.$router.push(item.path)
        //     sessionStorage.setItem('idx', 0)
        //     window.loading.close();
        //   } else {
        //     this.$message.error(res.msg)
        //   }
        // })
        // } else {
        // this.curId = i
        // this.$router.push(item.path)
        // sessionStorage.setItem('idx', 0)
        // window.loading ?  window.loading.close() : false
        // }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .educa_wrap{
    width: 100%;
    height: 100%;
    background: #F6F8FB;
    .educa_main{
      height: calc(100% - 64px);
      display: flex;
      justify-content: space-between;
      overflow: auto;
      .educa_menu{
        height: 100%;
        background: #fff;
        position: relative;
        .educa_menu_box{
          width: 140px;
          overflow: hidden;
          transition: .4s all;
        }
        .educa_menu_title{
          height: 40px;
          display: flex;
          align-items: center;
          border-bottom: 1px solid #5397F7;
          img{
            height: 14px;
            margin: 0 10px 0 15px;
          }
          span{
            font-size:12px;
            font-weight:normal;
            line-height: 40px;
            color:#5397F7;
          }
        }
        ul{
          li{
            width:115px;
            height:32px;
            background:#fff;
            border-radius:4px;
            margin: 10px;
            font-size:12px;
            font-weight:normal;
            color:#5D646E;
            padding-left: 33px;
            box-sizing: border-box;
            position: relative;
            line-height: 32px;
            cursor: pointer;
            &:hover{
              background: #F6F8FB;
              color:#5D646E;
              &::after{
                background: #99A0AA;
              }
            }
            &::after{
              position: absolute;
              left: 15px;
              top: 15px;
              content: '';
              width: 3px;
              height: 3px;
              background: #99A0AA;
              border-radius: 50%;
            }
          }
          .active{
            background: #5397F7 !important;
            color: #fff !important;
            &::after{
              background: #fff !important;
            }
          }
        }
        .switchImg{
          width: 16px;
          position: absolute;
          right: -16px;
          top: 0;
          bottom: 0;
          margin: auto;
          cursor: pointer;
        }
      }
      .educa_content{
        min-width: 1210px;
        height: 100%;
        margin-left: 16px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/views/educationalAdmin/educational.vue